/** @file Allocates the per-entity compile cache used by recompile (keyed by document object identity). */
import type { CompileCache } from './compileCache';

/** Empty cache. */
export function createCompileCache(): CompileCache {
  return {
    bones: new WeakMap(),
    attachments: new WeakMap(),
    animations: new WeakMap(),
    skinning: new WeakMap(),
    stages: new Map(),
    maps: new Map(),
    lastDoc: null,
    lastLayout: null,
    lastResult: null,
  };
}
